<template>
  <div class="">
    <v-tabs :value="selectedTab"
            class="rounded-lg white--text"
            background-color="secondary"
            active-class="primary"
            color="#FF8700">
      <v-tab @click="changeRoute(tab)" v-for="tab in tabs" class="white--text mr-2">{{ tab.title }}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "BalanceSheetTabs",
  data() {
    return {
      tabs: [
        {title: 'ترازنامه کلی', detailed: false},
        {title: 'ترازنامه جزئی', detailed: true},
      ]
    };
  },
  props: {
    detailed: {
      default: false
    },
  },
  mounted() {
  },
  computed: {
    selectedTab() {
      if (this.detailed) {
        return 1
      } else {
        return 0
      }
    },
  },
  methods: {
    to(detailed) {
      if (detailed){
        return {
          name: "BalanceSheetReport",
          params: {
            detailed: "detailed",
          },
        };
      } else {
        return {
          name: "BalanceSheetReport",
        };
      }
    },

    changeRoute(tab) {
      this.$router.push(this.to(tab.detailed))
    }
  }

};
</script>

<style scoped lang="scss">
</style>

